const EmailType = Object.freeze({
    HTML_EMAIL: { value: 'html_email', text: 'HTMLメール' },
    NEW_PROGRAM: { value: 'new_program', text: '新着プログラム' },
    NEW_SESSION: { value: 'new_session', text: 'セッションのお知らせ' },
});

export default EmailType;
